
let ed_form = document.getElementById("webform-submission-activity-text-form-paragraph-15309-add-form"); 

function forcePageReload() {
  window.addEventListener( "pageshow", function ( event ) {
    var historyTraversal = event.persisted || 
                           ( typeof window.performance != "undefined" && 
                                window.performance.navigation.type === 2 );
    if ( historyTraversal ) {
      // Handle page restore.
      window.location.reload();
    }
  });
}

export function init() {
  if (ed_form) {
    forcePageReload();
  }
}

export default {
  init
};
